import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from "../config/analyticsTrack";
import "./GHT.css"
import Logo from './assets/logo.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Header from './components/Header';
import gi1 from './assets/gi1.png'
import gi2 from './assets/gi2.png'
import gi3 from './assets/gi3.png'
import gi4 from './assets/gi4.png'
import gi5 from './assets/gi5.png'
import gi6 from './assets/gi6.png'
import gi7 from './assets/gi7.png'
import Footer from './Footer';

export default function GlobalInitiatives(props) {


    useEffect(() => {
        analyticsUserTrack("GHT - Global Initiatives", "Landing");
        window.scrollTo(0, 0);
    }, [])

    return <div className='version-2 GHT global-initiatives'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/GHT"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                <Header page="social-impact" />
            </div>
        </div>
        <div style={{ marginTop: 80 }}></div>
        <div className="d-flex flex-column align-items-center">
            <div className='mt-5' style={{ maxWidth: 250 }}>
                <Link to={Config.projectUrl + "/GHT"}>
                    <img className='img-fluid' src={Logo}></img>
                </Link>
            </div>
            <div className='my-3 montserrat-font-family' style={{ fontWeight: "bold", color: "#f5a623" }}>Advancing Global Neurosurgery With Meaningful Connectivity</div>
        </div>
        <div className='container pb-5' style={{ maxWidth: 800 }}>
            <div className='d-flex'>
                <div className='icon'>
                    <img className='img-fluid' src={gi1} />
                </div>
                <div className='flex-1'>
                    <div className="initiatives-container">
                        <p style={{ fontWeight: 700, color: "#0A4E53" }}>
                            Global Neurosurgery Initiatives
                        </p>
                        <p style={{ fontWeight: 700, color: "#21A89F" }}>International</p>
                        <br />
                        <p className='cursor-pointer'>
                            <a style={{ fontWeight: 700, color: "#0A4E53" }} href="https://wfns.org/" target="_blank" className='global-in-link cursor-pointer'> World Federation of Neurosurgical Societies (WFNS)</a>
                        </p>
                        <p style={{ fontWeight: 700, color: "#F5A623" }}>
                            Rabat Reference Center (Morocco)
                        </p>
                        <p>
                            Established in 2002, this center was the first WFNS-accredited training
                            facility in Africa.
                            <br />
                            It offers both full five-year neurosurgical residencies and short-term
                            training programs for African neurosurgeons. Trainees receive annual fellowships from the
                            WFNS Foundation to support their education. Notably,<a className='cursor-pointer global-in-link' href="https://en.wikipedia.org/wiki/Claire_Karekezi?utm_source=chatgpt.com" target="_blank"> Dr. Claire Karekezi,
                                Rwanda's first female neurosurgeon</a>, is an alumna of this program. <a className='cursor-pointer global-in-link' href="https://www.sciencedirect.com/science/article/abs/pii/S187887501301382X" target="_blank">​WFNS Rabat Center</a> ; <a href="https://wfns.org/training-centers/5/?utm_source=chatgpt.com" className='cursor-pointer global-in-link' target="_blank">Rabat Reference Center Criteria</a>
                        </p>
                        <p style={{ fontWeight: 700, color: "#F5A623" }}>Africa 100 Program</p>
                        <p>
                            Launched in 2012 in collaboration with Professor Madjid Samii, WFNS
                            appointed Ambassador for Africa. This initiative aims to train 100 African
                            neurosurgeons through WFNS-accredited centers. The program provides annual scholarships of USD $6000 per annum to support trainees, with the goal of addressing the
                            continent's
                            neurosurgical workforce shortage.
                        </p>
                        <p style={{ fontWeight: 700, color: "#F5A623" }}>
                            Support for Local Training Centers
                        </p>
                        <p>
                            WFNS collaborates with local residency programs and reference centers
                            across Africa
                            to provide comprehensive neurosurgical training. These centers offer
                            full training
                            programs and are instrumental in developing local expertise.<a className='global-in-link cursor-pointer' href="https://www.researchgate.net/publication/332182535_Takeoff_of_African_Neurosurgery_and_the_World_Federation_of_Neurosurgical_Societies_Rabat_Training_Center_WFNS-RTC_Alumni?utm_source=chatgpt.com" target="_blank">​WFNS RTC</a>
                        </p>
                        <p style={{ fontWeight: 700, color: "#F5A623" }}>
                            Advocacy and Policy Engagement
                        </p>
                        <p>
                            WFNS actively advocates for increased investment in neurosurgical
                            infrastructure and
                            training within Africa. The organization emphasizes the need for
                            sustainable funding
                            and policy support to overcome challenges such as limited resources and
                            workforce
                            deficits.<a href="https://thejns.org/view/journals/j-neurosurg/138/4/article-p1098.xml?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">​The Journal of Neurological Surgery</a>
                        </p>
                        <br />
                        <p style={{ fontWeight: 700, color: "#0A4E53" }}>
                            <a href="https://fiens.org/" className='global-in-link cursor-pointer' target="_blank">Foundation for International Education in Neurosurgery (FIENS)</a>
                        </p>
                        <p>FIENS has been instrumental in enhancing neurosurgical education across Africa. Their contributions include:<a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC7398343/?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">​WFNS, PMC</a></p>
                        <ul>
                            <li>
                                <strong style={{ color: "#F5A623" }}>Bootcamps</strong>: Since 2015,
                                FIENS has conducted neurosurgical boot camps in countries such as
                                South Africa, Zimbabwe, Nigeria, Kenya, and Tanzania, focusing on
                                hands-on training and skill development.
                            </li>
                            <li>
                                <strong style={{ color: "#F5A623" }}>Fellowships</strong>: Offering
                                fellowships to neurosurgeons from low- and middle-income countries to
                                refine their skills through both virtual and in-person programs.
                            </li>
                            <li>
                                <strong style={{ color: "#F5A623" }}>
                                    Virtual Visiting Professors
                                </strong>
                                : Providing online lectures and mentorship to support continuous
                                medical education.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='d-flex mt-3'>
                <div className='icon'>
                    <img className='img-fluid' src={gi2} />
                </div>
                <div className='flex-1'>
                    <div>
                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "26px", letterSpacing: "0em", textTransform: "none", listStyleType: "none" }}>
                            <span style={{ fontSize: "1em", fontWeight: "700", fontStyle: "normal", color: "rgb(33, 168, 159)", fontKerning: "none", textDecoration: "none" }}>
                                Africa
                            </span>
                        </p>

                        <p><br /></p>

                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", letterSpacing: "0em", textTransform: "none", listStyleType: "none" }}>
                            <span>
                                <a href="https://africa-caans.org/" className='global-in-link cursor-pointer' target="_blank" style={{ fontWeight: "700", color: "rgb(10, 78, 83)" }}>
                                    Continental Association of African Neurosurgical Societies (CAANS)
                                </a>
                            </span>
                        </p>

                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", letterSpacing: "0em" }}>
                            <span style={{ fontWeight: "700", color: "rgb(245, 166, 35)" }}>
                                Established to unify and represent neurosurgical societies across Africa
                            </span>
                            <span>
                                , CAANS focuses
                                on enhancing neurosurgical care through education, training, and collaborative research.
                            </span>
                        </p>
                        <p><br /></p>
                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", letterSpacing: "0em", textTransform: "none", listStyleType: "none" }}>
                            <span>
                                <a href="https://www.cosecsa.org/" className='global-in-link cursor-pointer' target="_blank" style={{ fontWeight: "700", color: "rgb(10, 78, 83)" }} >
                                    College of Surgeons of East, Central and Southern Africa (COSECSA).
                                </a>
                            </span>
                        </p>
                        <p>
                            <span style={{ fontWeight: "700", color: "rgb(245, 166, 35)" }}>
                                COSECSA offers standardized surgical training across 14 countries in East, Central, and
                            </span>
                            <span style={{ fontWeight: "700", color: "rgb(245, 166, 35)" }}>
                                Southern Africa
                            </span>
                            <span>
                                . The neurosurgery training program was initiated through the efforts of Dr
                                Mahmood Qureshi, Dr Paul Young and FIENS. The neurosurgery training program
                                commenced in 2006, and has been accredited as a WFNS Reference Training site
                                (Anglophone).
                            </span>
                        </p>

                        <p><br /></p>

                        <p>
                            <span>
                                It is referred to as the
                            </span>
                            <span> </span>
                            <span style={{ fontWeight: "700", color: "rgb(245, 166, 35)" }}>Consortium of Collaborative Neurosurgical Sites of Training in the
                                ECSA region (C-CNS-ECSAR)
                            </span>
                            <span>
                                . Collaborating with multiple sites in Kenya, Uganda, Tanzania,
                                Zanzibar, Rwanda, Malawi, Ethiopia, and Zambia along with international partners in
                                Mumbai, Valencia and Alicante in Spain, and the UK, the program aims to:
                            </span>
                        </p>

                        <ul style={{ marginLeft: "0em" }}>
                            <li>
                                <span>Increase the regional neurosurgical workforce.</span>
                            </li>
                            <li>
                                <span>Enhance surgical education and training standards, and encourage Research in the ECSA region.</span>
                            </li>
                        </ul>

                        <p>
                            <span>
                                Universities in the region have also developed Masters programs in neurosurgery to complement the COSECSA based training. &nbsp;
                            </span>
                            <span style={{ fontWeight: "700", color: "rgb(245, 166, 35)" }}>
                                Over 150 neurosurgeons have been trained in
                                the region since the initiatives started.
                            </span>
                            <a href="https://globalhealth.duke.edu/student-showcases/fulfilling-specialist-neurosurgery-workforce-needs-africa-swot-analysis-training?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">​Duke Global Health Institute</a>
                        </p>

                        <p><br /></p>

                        <p>
                            <span style={{ fontWeight: "700" }}>
                                <a href="https://nansorg.com/" style={{ fontWeight: "700" }} className='global-in-link cursor-pointer' target="_blank">Nigerian Academy of Neurological Surgeons (NANS)</a>
                            </span>
                        </p>

                        <p>
                            <span>
                                Founded in 2006, NANS is dedicated to advancing neurosurgical practice and education in Nigeria, contributing to the broader goal of capacity building within the region.<a href="https://www.sciencedirect.com/science/article/abs/pii/S1878875024003917?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">ScienceDirect</a>
                            </span>
                        </p>

                        <p><br /></p>

                        <p>
                            <span >
                                <a href="https://www.madaktari.org/who-we-are/our-history/" style={{ fontWeight: "700" }} className='global-in-link cursor-pointer' target="_blank"> Madaktari Africa's Train-Forward Model</a>
                            </span>
                        </p>

                        <p>
                            <span>
                                Implemented in Tanzania, this model trains local healthcare workers in basic neurosurgical procedures, promoting sustainable care delivery.<a href="https://pubmed.ncbi.nlm.nih.gov/25216067/?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">PubMed</a>
                            </span>
                        </p>

                        <p><br /></p>

                        <p>
                            <span style={{ fontWeight: "700" }}>
                                <a href="https://uganda.cure.org/news/cure-uganda-announces-new-strategic-partnership-to-support-neurosurgical-training-in-africa/?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">CURE Children's Hospital of Uganda</a>
                            </span>
                        </p>

                        <p>
                            <span>
                                CURE Uganda performs a high volume of hydrocephalus and spina bifida surgeries. Through strategic partnerships, it focuses on:
                            </span>
                        </p>

                        <ul style={{ marginLeft: "0em" }}>
                            <li>
                                <span>Expanding neurosurgical training programs.</span>
                            </li>
                            <li>
                                <span>Improving pediatric neurosurgical care across the region.  </span>
                            </li>
                        </ul>

                        <p><br /></p>

                        <p>
                            <span style={{ fontWeight: "700" }}>
                                Brazil-Angola Partnership
                            </span>
                        </p>

                        <p>
                            <span>
                                A collaboration between Brazil and Angola has been established to address the
                                neurosurgical workforce shortage in Angola. This partnership focuses on training Angolan
                                neurosurgeons through fellowships and hands-on surgical experiences, aiming to build a
                                sustainable neurosurgical program within the country.<a href="https://pubmed.ncbi.nlm.nih.gov/30366143/" className='global-in-link cursor-pointer' target="_blank">PubMed</a>
                            </span>
                        </p>
                        <p><br /></p>
                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", letterSpacing: "0em", textTransform: "none" }}>
                            <span >
                                <a href='https://africanbrainchild.com/' className='global-in-link cursor-pointer' target="_blank" style={{ fontSize: "1em", fontWeight: 700, fontStyle: "normal", color: "rgb(10, 78, 83)", fontKerning: "normal", textDecoration: "none" }}>African Brain Child</a>
                            </span>
                        </p>

                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", letterSpacing: "0em", textTransform: "none" }}>
                            <span style={{ fontSize: "1em", fontWeight: 400 }}>Based in </span>
                            <span style={{ fontSize: "1em", fontWeight: 700, color: "rgb(245, 166, 35)" }}>South Africa</span>
                            <span style={{ fontSize: "1em", fontWeight: 400 }}>
                                , this initiative aims to advance the understanding and health of the
                                developing brain through capacity building activities. Projects include developing local
                                infrastructure, building strategic networks, and hosting conferences to promote neurosurgical
                                education and collaboration across the continent.
                            </span>
                        </p>

                        <p><br /></p>

                        <p>
                            <span style={{ fontSize: "1em", fontWeight: 700, color: "rgb(10, 78, 83)" }}>
                                Telemedicine Initiatives
                            </span>
                        </p>

                        <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", letterSpacing: "0em" }}>
                            <span style={{ fontSize: "1em", fontWeight: 400 }}>
                                The adoption of telemedicine has been instrumental in advancing neurosurgical care in Africa by
                                facilitating
                            </span>
                            <span style={{ fontSize: "1em", fontWeight: 700, color: "rgb(245, 166, 35)" }}> remote consultations, education, and collaborative case management
                            </span>
                            <span style={{ fontSize: "1em", fontWeight: 400 }}>
                                , thereby overcoming geographical barriers and resource limitations.<a href="https://ejns.springeropen.com/articles/10.1186/s41984-025-00397-7?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">​Impact of Telemedicine</a>
                            </span>
                        </p>

                        <p><br /></p>
                    </div>
                </div>

            </div>
            <div className='d-flex mt-3'>
                <div className='icon'>
                    <img className='img-fluid' src={gi3} />
                </div>
                <div className='flex-1'>
                    <p style={{ color: "rgb(33, 168, 159)", fontWeight: 700, fontSize: "1em", lineHeight: "26px" }}>
                        Europe
                    </p>

                    <p><br /></p>

                    <p>
                        <span >
                            <a href="https://www.eans.org/news/697021/EANS-Global-Humanitarian-Committee-EANS-First-African-Training-Course-in-Tanzania.htm" style={{ fontWeight: 700, fontSize: "1em", color: "rgb(10, 78, 83)" }} className='global-in-link cursor-pointer' target="_blank">European Association of Neurosurgical Societies (EANS)</a>
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 700, fontSize: "1em", color: "rgb(10, 78, 83)" }}>
                            Global Humanitarian Committee
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 700, fontSize: "1em", color: "rgb(245, 166, 35)" }}>
                            EANS has extended its training programs to Africa,
                        </span>
                        <span style={{ fontWeight: 400 }}>
                            {" "}
                            with the first African EANS-Supported
                            Training Course held in Tanzania in May 2025. Objectives include:
                        </span>
                    </p>

                    <ul>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                Improving neurosurgical education and mentorship.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                Fostering collaboration between European and African neurosurgeons.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 400 }}>
                                Building sustainable training platforms to enhance neurosurgical care in East Africa.
                            </span>
                        </li>
                    </ul>

                    <p><br /></p>

                    <p>
                        <span >
                            <a href='https://nedfundacion.org/en/' style={{ fontWeight: 700 }} className='global-in-link cursor-pointer' target="_blank">The Neurosurgery Education and Development (NED) Foundation (Spain)</a>
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 400 }}>
                            The (NED) Foundation operates the NED Institute in Zanzibar, Tanzania. Their model emphasizes
                            sustainable neurosurgical care through local training, academic activities, and international
                            surgical camps.
                        </span>{" "}
                        <span style={{ fontWeight: 700, color: "rgb(245, 166, 35)" }}>
                            Success factors include collaboration with COSECSA, FIENS, and support from
                            the Government of Zanzibar.
                        </span>
                        <a href="https://pubmed.ncbi.nlm.nih.gov/30269584/?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">PubMed</a>
                    </p>

                    <p><br /></p>

                    <p>
                        <span style={{ fontWeight: 700 }}>
                            <a href="https://www.sbns.org.uk/global.html?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">Society of British Neurological Surgeons (SBNS)</a>
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 400 }}>
                            SBNS supports global neurosurgery by facilitating research networks, multicenter trials, and
                            providing training and education through visiting experts from the UK and Ireland.
                        </span>
                    </p>

                    <p><br /></p>

                    <p>
                        <span style={{ fontWeight: 700 }}>
                            <a href='https://www.sanc.se/' className='global-in-link cursor-pointer' target="_blank">Swedish African Neurosurgical Collaboration</a>
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 400 }}>
                            This collaboration focuses on capacity building through training and mentorship, particularly in
                            West Africa. It emphasizes a "twinning" model, pairing institutions in Sweden and Nigeria to
                            enhance neurosurgical education and service delivery.
                        </span>
                    </p>

                    <p><br /></p>

                    <p>
                        <span style={{ fontWeight: 700 }}>
                            <a href='https://fondazioneasino.it/en/what-we-do/training-projects/global-training-project' className='global-in-link cursor-pointer' target="_blank" style={{ fontWeight: 700 }}>Asino Foundation's Global Training Project</a>
                        </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 400 }}>
                            The Asino Foundation supports neurosurgical training by organizing courses in countries like
                            Morocco, Kenya, Nigeria, and Cameroon, aiming to provide equal training opportunities
                            worldwide.
                        </span>
                    </p>
                </div>
            </div>
            <div className='d-flex mt-3'>
                <div className='icon'>
                    <img className='img-fluid' src={gi4} />
                </div>
                <div className='flex-1'>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "24px", letterSpacing: "0em", textTransform: "none" }}>
                        <span style={{ fontSize: "1em", fontWeight: 700, fontStyle: "normal", color: "rgb(33, 168, 159)", fontKerning: "normal", textDecoration: "none" }}>
                            Middle East and Asia
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span style={{ fontWeight: 700 }}>Aga Khan University (Pakistan)</span>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>
                            Through its <a href="https://scholars.aku.edu/en/publications/the-power-of-advocacy-in-global-neurosurgery" className='global-in-link cursor-pointer' target="_blank" style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>Global Neurosurgery program</a>, Aga Khan University collaborates with institutions
                            in Africa to enhance neurosurgical training and care. Faculty and students engage in clinical
                            rotations and research projects aimed at improving neurosurgical services in resource- limited settings.
                        </span>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>Through its </span>
                        <span style={{ fontWeight: 700, color: "rgb(245, 166, 35)" }}>
                            Medical College in East Africa,
                        </span>
                        <span> Aga Khan University engages in partnerships aimed at strengthening neurosurgical training and services in the region.<a href="https://ecommons.aku.edu/eastafrica_fhs_mc_gen_surg/128/?utm_source=chatgpt.com" className='global-in-link cursor-pointer' target="_blank">​eCommons</a>
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <a href='https://asiancns.com/' className='global-in-link cursor-pointer' target="_blank" style={{ fontWeight: 700, color: "rgb(10, 78, 83)" }}>Asian Congress of Neurological Surgeons (ACNS)</a>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>
                            ACNS contributes to neurosurgical development in Africa by organizing training courses,
                            workshops, and collaborative research projects. Their efforts aim to build capacity and
                            improve neurosurgical care across the continent.
                        </span>
                    </p>
                    <p><br /></p>
                </div>
            </div>
            <div className='d-flex mt-3'>
                <div className='icon'>
                    <img className='img-fluid' src={gi5} />
                </div>
                <div className='flex-1'>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "26px" }}>
                        <span style={{ fontWeight: 700, color: "rgb(33, 168, 159)" }}>Australia and New Zealand</span>
                    </p>
                    <p><br /></p>
                </div>
            </div>
            <div className='d-flex mt-3'>
                <div className='icon'>
                    <img className='img-fluid' src={gi6} />
                </div>
                <div className='flex-1'>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span ><a href='https://www.surgeons.org/' style={{ fontWeight: 700, color: "rgb(10, 78, 83)" }} className='global-in-link cursor-pointer' target="_blank">Royal Australasian College of Surgeons (RACS)</a></span>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>
                            RACS conducts global health programs that include neurosurgical training and capacity
                            building in various African countries. Their initiatives focus on improving surgical care
                            through education, mentorship, and infrastructure development.
                        </span>
                    </p>
                    <p><br /></p>
                </div>
            </div>
            <div className='d-flex mt-3'>
                <div className='icon'>
                    <img className='img-fluid' src={gi7} />
                </div>
                <div className='flex-1'>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "26px" }}>
                        <span style={{ fontWeight: 700, color: "rgb(33, 168, 159)" }}>United States of America</span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <a style={{ fontWeight: 700 }} href='https://www.aans.org/' className='global-in-link cursor-pointer' target="_blank">American Association of Neurological Surgeons (AANS)</a>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>
                            A professional organization representing over 8,000 neurosurgeons and allied professionals worldwide. Founded in 1931, the AANS advances neurosurgical care through education, research, and advocacy. It promotes excellence in the treatment of brain, spine, and nervous system disorders, and hosts the leading annual neurosurgical meeting in the U.S.
                            <a href='https://thejns.org/focus/view/journals/neurosurg-focus/45/4/article-pE4.xml?' className='global-in-link cursor-pointer' target="_blank" style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>AANS Journal of Neurosurgery: Haiti</a>
                        </span>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }} className='mt-3'>
                        <a style={{ fontWeight: 700, color: "rgb(10, 78, 83)" }} href='https://www.barrowneuro.org/' className='global-in-link cursor-pointer' target="_blank">Barrow Neurological Institute</a>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>
                            Barrow offers a fellowship program that allows neurosurgeons to engage in global health
                            initiatives, including those in Africa. The fellowship focuses on providing surgical care,
                            education, and capacity building in underserved regions.
                        </span>
                    </p>
                    <ul style={{ marginLeft: 0 }}>
                        <li style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", listStyleType: "disc" }}>
                            <span style={{ fontWeight: 700, color: "rgb(245, 166, 35)" }}>Global Neurotrauma Fellowship (GNTF)</span>
                            <ul style={{ marginLeft: "-1.7em" }}>
                                <li style={{ color: "rgb(10, 78, 83)", lineHeight: "22px", listStyleType: "circle" }}>
                                    <span>
                                        Established in 2015, the GNTF is a collaboration between the Barrow Neurological
                                        Institute (USA) and the Meditech Foundation (Colombia). While its primary focus is
                                        on Latin America, the program's model of international collaboration and capacity
                                        building serves as a potential framework for similar initiatives targeting Africa.<a href='https://www.frontiersin.org/journals/surgery/articles/10.3389/fsurg.2021.633774/full' className='global-in-link cursor-pointer' target="_blank" style={{ color: "rgb(10, 78, 83)" }}>​International Neurotrauma.</a>
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <p><br /></p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <a style={{ fontWeight: 700, color: "rgb(10, 78, 83)" }} href='https://www.dukeglobalneurosurgery.com/' className='global-in-link cursor-pointer' target="_blank">Duke Global Neurosurgery and Neurology (DGNN)</a>
                    </p>
                    <p style={{ color: "rgb(10, 78, 83)", lineHeight: "22px" }}>
                        <span>
                            Established in 2014, DGNN has been instrumental in enhancing neurosurgical capacity in
                            East Africa, particularly Uganda. Key achievements include:
                        </span>
                    </p>
                    <ul style={{ marginLeft: 0 }}>
                        <li style={{ lineHeight: "22px", listStyleType: "disc" }}>
                            <span style={{ fontWeight: 700, color: "rgb(245, 166, 35)" }}>
                                Tripling the number of neurosurgeons in Uganda.
                            </span>
                        </li>
                        <li style={{ lineHeight: "22px", listStyleType: "disc" }}>
                            <span>Establishing partnerships with Mulago National Referral Hospital and Mbarara Regional Referral Hospital.</span>
                        </li>
                        <li style={{ lineHeight: "22px", listStyleType: "disc" }}>
                            <span>
                                Launching a <span style={{ fontWeight: 700, color: "rgb(245, 166, 35)" }}>year-round neuroscience institute in collaboration with Mbarara University</span><br />
                                <span style={{ fontWeight: 700, color: "rgb(245, 166, 35)" }}>of Science and Technology.</span>
                            </span>
                        </li>
                        <li style={{ lineHeight: "22px", listStyleType: "disc" }}>
                            <span>Conducting annual surgical camps and training programs.</span>
                        </li>
                        <li style={{ lineHeight: "22px", listStyleType: "disc" }}>
                            <span>
                                Engaging in research and policy development to improve neurosurgical systems in
                                countries like Nigeria, Uganda, and the Democratic Republic of the Congo.
                            </span>
                        </li>
                        <span style={{ lineHeight: "22px", listStyleType: "disc" }}>
                            <a href='https://neurosurgery.duke.edu/report-global-neurosurgery' className='global-in-link cursor-pointer' target="_blank">Duke in East Africa</a>; <a href="https://bassconnections.duke.edu/project/building-sustainable-neurosurgical-systems-developing-countries-2023-2024/" className='global-in-link cursor-pointer' target="_blank">Sustainable Neurosurgical Systems</a>
                        </span>
                    </ul>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em' }}>
                        <a style={{ fontSize: '1em', fontWeight: 700, color: 'rgb(10, 78, 83)' }} href='https://www.pgssc.org/' className='global-in-link cursor-pointer' target="_blank">
                            Harvard Medical School - Program in Global Surgery and Social Change (PGSSC);
                        </a>
                    </p>
                    {/* <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em' }}>
                        <a style={{ fontSize: '1em', fontWeight: 400 }} href='https://www.pgssc.org/' className='global-in-link cursor-pointer' target="_blank">
                            Program in Global Surgery and Social Change (PGSSC)
                        </a>
                    </p> */}
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em' }}>
                        <span style={{ fontSize: '1em', fontWeight: 400 }}>
                            The Global Neurosurgery Initiative (GNI) at PGSSC, launched in 2018, addresses
                            neurosurgical disparities in low- and middle-income countries. Activities include:
                        </span>
                    </p>
                    <ul style={{ marginLeft: '0em' }}>
                        <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em', listStyleType: 'disc' }}>
                            <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                Pediatric neurosurgical training
                            </span>
                            <span> in Mbale, Uganda.</span>
                        </li>
                        <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em', listStyleType: 'disc' }}>
                            <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                Research on health policy and economic implications of neurosurgical care.
                            </span>
                        </li>
                        <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em', listStyleType: 'disc' }}>
                            <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                Global surveys in partnership with the World Federation of Neurosurgical Societies
                            </span>
                            <span> to</span>
                            <span>assess neurosurgical capacity.​<a href="https://thejns.org/view/journals/j-neurosurg/131/4/article-p993.xml?utm_source=chatgpt.com" style={{ color: 'rgb(10, 78, 83)' }} className='global-in-link cursor-pointer' target="_blank">The Journal of Neurosurgery</a> </span>
                        </li>
                    </ul>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <a style={{ fontWeight: 700, color: 'rgb(10, 78, 83)' }} href='https://www.thehuntfoundation.org/' className='global-in-link cursor-pointer' target="_blank">
                            The Hunt Foundation (USA)
                        </a>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>
                            In Gabon, the Hunt Foundation provides training programs to local surgeons, focusing on
                            advanced neurosurgical techniques such as minimally invasive spinal surgery and base of
                            skull surgeries. The foundation also assists in equipping neurosurgical suites with
                            necessary technologies.
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <a style={{ fontWeight: 700, color: 'rgb(10, 78, 83)' }} href='https://www.fic.nih.gov/Grants/Search/Pages/ncdlifespan-d43tw012030.aspx' className='global-in-link cursor-pointer' target="_blank">
                            University of California, San Francisco (UCSF) – TALENTS Program
                        </a>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>
                            The "Training Africans to Lead and Execute Neurological Trials &amp; Studies" (TALENTS)
                            program, led by UCSF in collaboration with the University of Ibadan in Nigeria, aims to
                            develop and sustain capacity to conduct neurological research in Africa.
                        </span>
                        <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                            The program
                            offers formal training in the design, execution, and leadership of neurological research
                        </span>
                        <span> to selected African scholars.
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>

                        <a href='https://medschool.cuanschutz.edu/neurosurgery/education-and-training/global-neurosurgery' className='global-in-link cursor-pointer' target="_blank" style={{ fontWeight: 700, color: 'rgb(10, 78, 83)' }}> University of Colorado - Partnership with Muhimbili Orthopedic and Neurosurgical Institute (MOI)</a>

                    </p>
                    {/* <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                        <a href='https://medschool.cuanschutz.edu/neurosurgery/education-and-training/global-neurosurgery' className='global-in-link cursor-pointer' target="_blank"> </a>
                        </span>
                    </p> */}
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>
                            Since 2007, the University of Colorado has partnered with MOI in Tanzania to improve
                            neurosurgical care. The collaboration includes training general surgeons in basic
                            neurosurgical skills and supporting the development of a neurosurgery residency program.
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <a style={{ fontWeight: 700, color: 'rgb(10, 78, 83)' }} href='https://med.stanford.edu/neurosurgery/divisions/globalhealth?utm_source=chatgpt.com' className='global-in-link cursor-pointer' target="_blank">
                            Stanford Global Health Neurosurgery
                        </a>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>
                            Stanford's initiative involves collaborations with Ugandan neurosurgical residency programs,
                            providing clinical care, conducting research, and facilitating knowledge exchange.
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <a style={{ fontWeight: 700, color: 'rgb(10, 78, 83)' }} href='https://www.vumc.org/neurosurgerydept/global-neurosurgery-program?' className='global-in-link cursor-pointer' target="_blank">
                            Vanderbilt University Medical Center - Global Neurosurgery Program
                        </a>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>Vanderbilt's program </span>
                        <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                            collaborates with partners in several African countries, including
                            Ethiopia, Ghana, Kenya, Malawi, Nigeria, South Africa, Tanzania, Uganda, and Zambia.
                        </span>
                        <span>
                            &nbsp; The initiative aims to enhance neurosurgical training, strengthen care delivery, and promote
                            research in low-resource settings.
                        </span>
                    </p>
                    <p><br /></p>
                    {/* <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span style={{ fontWeight: 700 }}>
                            Washington University in St. Louis - SMART Africa Center
                        </span>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>
                            While primarily focused on child mental health, the SMART Africa Center at Washington University emphasizes capacity building through leadership development, integration of mental health services in community settings, and strengthening the mental health workforce in African countries.
                        </span>
                    </p>
                    <p><br /></p> */}
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <a style={{ fontWeight: 700,color: 'rgb(10, 78, 83)' }} href='https://neurosurgery.weill.cornell.edu/education/global-health?' className='global-in-link cursor-pointer' target="_blank">
                            Weill Cornell Medicine - Global Neurosurgical Health Initiative
                        </a>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>
                            Originating in Tanzania, this initiative emphasizes training over charity, aiming for self-sufficiency in neurosurgical care. It has expanded to countries including Senegal, focusing on:
                            <ul>
                                <li>
                                    Enhancing access to neurosurgical services.
                                </li>
                                <li>
                                    Delivering quality care through education and infrastructure development.
                                </li>
                            </ul>
                        </span>
                    </p>
                    <p><br /></p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <a style={{ fontWeight: 700,color: 'rgb(10, 78, 83)', }} href='https://www.mcw.edu/departments/neurosurgery/global-neurosurgery?' className='global-in-link cursor-pointer' target="_blank">
                            Medical College of Wisconsin - Global Neurosurgery Program
                        </a>
                    </p>
                    <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}>
                        <span>The Medical College of Wisconsin's program has educated over 2,600 medical professionals across 26 countries, including those in Africa. The initiative focuses on providing in-person courses to enhance neurosurgical education and care .</span>
                    </p>
                </div>
            </div>
            <div className='d-flex my-5'>
                <div className='icon'>
                </div>
                <div className='flex-1' style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                    This is a community resource. Please send submissions, updates, and edits to <a style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }} href={"mailto:?subject=Teqbahn&body="}>vidyasri@teqbahn.com</a>
                </div>
            </div>
        </div>
        <Footer />

    </div>
}
